__webpack_require__.p = "{{ STATIC_URL }}phonegap/www/";